import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { colors, menuOffset } from "../../theme";
import { Offer, OfferTitle, OfferButton, More } from "./supportTheme";

function SupportSharesOffer({ withButton }) {
  return (
    <Offer>
      <OfferTitle color={colors.red}>Parts sociales</OfferTitle>
      <h3>À partir de 1€</h3>
      {withButton && (
        <OfferButton as={Link} to="/soutien/parts-sociales">
          J'achète des parts sociales
        </OfferButton>
      )}
      <ul>
        <li>
          <i className="fa-fw fas fa-check" /> Soutenez financièrement Le Média
        </li>
        <li>
          <i className="fa-fw fas fa-check" /> Droit politique dans le cadre de
          la coopérative
        </li>
      </ul>
      {/* <div>
        <strong>-50%</strong> de réduction d’impôts sur l’achat de parts
        sociales
      </div> */}
      {withButton && (
        <More
          to="SCIC"
          offset={-Math.abs(parseInt(menuOffset, 10) + 10)}
          isDynamic
          smooth
          duration={400}
        >
          En savoir plus
        </More>
      )}
    </Offer>
  );
}

SupportSharesOffer.propTypes = {
  withButton: PropTypes.bool,
};

export default SupportSharesOffer;
